<template lang='pug'>
  el-form-item(label="时间")
    el-date-picker(
      v-model="timeRange"
      type="daterange"
      range-separator="至"
      value-format="yyyy-MM-dd"
      :clearable="false"
      :picker-options="pickerOptions"
      @input='emitInput'
    )
    el-button.custom--el-button(
      v-for="(item,key) in selectOptions"
      :key="key"
      type="text"
      @click.prevent="setTimeRange(item)"
    ) 最近{{item}}天
</template>
<script>
import moment from 'moment';

export default {
  props: {
    value: {
      type: Array,
      default() {
        return [];
      }
    },
    selectOptions: {
      type: Array,
      default() {
        return [30, 7];
      }
    },
    pickerOptions: {
      type: Object,
      default() {
        const nowDate = moment().subtract(1, 'days').toDate();
        return {
          disabledDate(time) {
            return time.getTime() >= nowDate.getTime() || time.getTime() <= new Date(2018, 0, 0);
          }
        };
      }
    }
  },
  data() {
    return {
      timeRange: [],
    };
  },
  mounted() {
    this.timeRange = this.value.length ? this.value : this.getTimeRange(this.selectOptions[0]);
    this.$emit('input', this.timeRange);
  },
  methods: {
    getTimeRange(num) {
      return [moment().subtract(num, 'days').format('YYYY-MM-DD'), moment().subtract(1, 'days').format('YYYY-MM-DD')];
    },
    setTimeRange(timeRange) {
      this.timeRange = this.getTimeRange(timeRange);
      this.$emit('input', this.timeRange);
      this.$emit('setTime');
    },
    emitInput() {
      this.$emit('input', this.timeRange);
    }
  }
};
</script>
<style lang="less" scoped>
.custom--el-button{
  margin-left: 30px;
  color: #6974A3;
}
</style>




// WEBPACK FOOTER //
// src/views/dataCenter/components/v-date-picker.vue?a0a48114